export const validation = {
  required: {
    required: 'This is a required field',
  },
  phone: {
    pattern: {
      value: /^\+?[0-9-() ]*$/,
      message: 'Fill in a valid phonenumber',
    },
    maxLength: {
      value: 14,
      message: 'Phonenumber is too long',
    },
    minLength: {
      value: 10,
      message: 'Phonenumber is too short',
    },
  },
  email: {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Fill in a valid email address',
    },
  },
  number: {
    pattern: {
      value: /^\d+$/,
      message: 'This field can only contain numbers',
    },
  },
  date: {
    pattern: {
      value: /^\d{4}-\d{2}-\d{2}$/,
      message: 'Fill in a valid date',
    },
  },
  address: {
    pattern: {
      value: /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]+$/,
      message: 'Fill in a valid address',
    },
  },
  password: {
    minLength: {
      value: 8,
      message: 'Password should contain at least 8 characters',
    },
  },
  textarea: {
    maxLength: {
      value: 255,
      message: 'This field contains too many characters (max 255)',
    },
  },
  postalCode: {
    pattern: {
      value: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
      message: 'Fill in a valid postal code',
    },
  },
  positiveInterger: {
    validate: (value: string) => {
      const isValid = parseInt(value) >= 0;
      return !value || isValid || 'This value should be above 0';
    },
  },
  time: {
    pattern: {
      value: /^(0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
      message: 'Fill in a valid time',
    },
  },
  iban: {
    pattern: {
      value: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/i,
      message: 'Fill in a valid IBAN number',
    },
    validate: (value: string) => {
      if (!value) return true;

      const iban = value.replace(/\s/g, '').toUpperCase();

      if (iban.startsWith('NL') && iban.length !== 18) {
        return 'Dutch IBAN numbers must be 18 characters long';
      }

      return true;
    },
  },
};
